import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-megapack-section relative py-10 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-220">
      <div className="absolute inset-0 bg-gradient-to-r from-megapack-bg/50 to-megapack-section opacity-50 pointer-events-none" data-id="element-221" />

      <div className="relative z-10 max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-222">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-6 md:mb-8 leading-tight" data-id="element-223">
          ¿Cuánto tiempo más vas a llegar <br className="hidden md:block" data-id="element-224" />a
          los finales sin el método correcto?
        </h2>

        <div className="space-y-2 text-megapack-gray text-[15px] md:text-xl max-w-2xl mx-auto" data-id="element-225">
          <p data-id="element-226">El problema no es que seas malo para estudiar.</p>
          <p data-id="element-227">Es que nadie te enseñó a estudiar materias técnicas.</p>
          <p className="text-white font-bold" data-id="element-228">Pero sí tiene solución.</p>
          <p className="text-megapack-cyan font-bold" data-id="element-229">Y está disponible hoy.</p>
        </div>
      </div>
    </section>;
};